module.exports = __webpack_public_path__ + "img/departments.09d7f2d0.svg";